import React, { useState } from 'react';
// @ts-ignore
import styles from './InputButtonGroup.module.scss';
import { joinClasses } from '../../../Utils/className.util';
import Text from '../Text/Text';
import useTranslation from '../../../Hooks/useTranslation';
import { FieldError } from 'react-hook-form';

interface InputButtonGroupProps {
	onChange?: any;
	onFocus?: any;
	onKeyPress?: any;
	onKeyUp?: any;
	onKeyDown?: any;
	placeholder?: string;
	required?: boolean;
	value?: string;
	className?: string;
	rows?: number;
	wrapperClassName?: string;
	onSearch: (text: string) => void;
	error?: FieldError;
}

const InputButtonGroup: React.FC<InputButtonGroupProps> = props => {
	const { t } = useTranslation();
	const {
		onChange,
		onSearch,
		onFocus,
		onKeyPress,
		onKeyUp,
		onKeyDown,
		placeholder,
		required = false,
		value,
		className,
		rows = 3,
		wrapperClassName,
	} = props;
	const error = false;
	const [inputValue, setInputValue] = useState(null);

	const handleOnChange = (e: any) => {
		onChange?.(e);
		setInputValue(e.target?.value);
	};

	const handleOnSearch = () => {
		if (inputValue) {
			onSearch(inputValue);
		}
	};

	// @ts-ignore
	const handleKeyDown = async event => {
		// on enter
		if (event.keyCode == 13) {
			handleOnSearch();
		}
	};

	return (
		<div className={styles.wrapper}>
			<div>
				<Text
					className={styles.text}
					tx={'base.shared.search'}
					firstUpper={true}
				/>
			</div>
			<div
				className={joinClasses([
					className,
					'form-control',
					styles.fakeInput,
					error && styles.invalid,
				])}>
				<input
					value={value}
					required={required}
					placeholder={t(placeholder)}
					onChange={handleOnChange}
					onBlur={handleOnChange}
					onKeyDown={handleKeyDown}
					className={styles.input}
				/>
				<div className={styles.button} onClick={handleOnSearch}>
					<Text tx={'base.shared.fileSearch'} inline={true} firstUpper={true} />
				</div>
			</div>

			{props.error && (
				<div className={styles.errorMessage}>
					<Text tx={props.error.message} inline={true} />
				</div>
			)}
		</div>
	);
};

export default InputButtonGroup;
